// constants, map for all possible claim statuses
// QA_PENDING_ALL is a pseudo-status, it groups pending, submitted, & settled for batches
export const CLAIM_STATUS = {
  CUSTOMER_CARE_OPEN: 'CUSTOMER_CARE_OPEN',
  CUSTOMER_CARE_RESOLVED: 'CUSTOMER_CARE_RESOLVED',
  QA_OPEN: 'QA_OPEN',
  QA_COMPLETE: 'QA_COMPLETE',
  QA_SUBMITTED: 'QA_SUBMITTED',
  QA_PENDING: 'QA_PENDING',
  QA_SETTLED: 'QA_SETTLED',
  QA_CLOSED: 'QA_CLOSED',
  QA_PENDING_ALL: 'QA_PENDING_ALL',
};

// map claim status label, displayed on the top right corder of each claim
export const CLAIM_STATUS_LABEL_MAP = {
  [CLAIM_STATUS.CUSTOMER_CARE_RESOLVED]: 'New',
  [CLAIM_STATUS.QA_OPEN]: 'Incomplete',
  [CLAIM_STATUS.QA_COMPLETE]: 'Complete',
  [CLAIM_STATUS.QA_SUBMITTED]: 'Submitted',
  [CLAIM_STATUS.QA_PENDING]: 'Pending',
  [CLAIM_STATUS.QA_SETTLED]: 'Settled',
  [CLAIM_STATUS.QA_CLOSED]: 'Archived',
  [CLAIM_STATUS.QA_PENDING_ALL]: 'All Resolutions',
};

export const CLAIM_TYPE = {
  CREDIT_REQUESTED: 'CREDIT_REQUESTED',
  REQUEST_ACKNOWLEDGMENT: 'REQUEST_ACKNOWLEDGMENT',
};

export const CLAIM_TYPE_LABEL_MAP = {
  [CLAIM_TYPE.CREDIT_REQUESTED]: 'Credit Requested',
  [CLAIM_TYPE.REQUEST_ACKNOWLEDGMENT]: 'Request Acknowledgement',
};

export const OPEN_CLAIMS_TOGGLE = [
  {
    status: CLAIM_STATUS.QA_OPEN,
    label: CLAIM_STATUS_LABEL_MAP[CLAIM_STATUS.QA_OPEN],
  },
  {
    status: CLAIM_STATUS.QA_COMPLETE,
    label: CLAIM_STATUS_LABEL_MAP[CLAIM_STATUS.QA_COMPLETE],
  },
];

// the corresponding query key name mapping with the backend api
export enum claimQueryKey {
  status = 'status',
  page = 'page',
  size = 'size',
  claimCategory = 'category_id',
  claimIssueCategory = 'type_id',
  claimIssueType = 'issue_id',
  resolutionType = 'resolution_id',
  tag = 'tag_id',
  claimPriority = 'priority',
  claimDefectSeverity = 'severity',
  supplier = 'supplier_id',
  lotNo = 'lot_no',
  productName = 'product_name',
  boxId = 'box_id',
  skuNo = 'sku',
  searchText = 'search_text',
  isUpdatedByCurrentUser = 'is_updated_by_current_user',
  dateDeliveredBegin = 'delivery_start_time_utc',
  dateDeliveredEnd = 'delivery_end_time_utc',
  batchCode = 'code',
  isBatchClosed = 'is_closed',
  isClaimFlagged = 'is_flagged',
  isProductQualityIssue = 'is_product_quality_issue',
}

export const PENDING_STATUSES = [
  CLAIM_STATUS.QA_PENDING_ALL,
  CLAIM_STATUS.QA_SUBMITTED,
  CLAIM_STATUS.QA_PENDING,
  CLAIM_STATUS.QA_SETTLED,
];
